export const sagaActions = {
	LOGIN_SAGA: 'LOGIN_SAGA',
	LOGIN_BY_TOKEN: 'LOGIN_BY_TOKEN',
}
  